@if (items$ | async; as items) {
<div class="container js-highlighted-product" [attr.data-name]="title$ | async">
  <label [ngClass]="activeLanguage$ | async">{{ title$ | async }}</label>
  @if (items.length > 0) {
  <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slickConfig">
    @for (item of items; track item; let i = $index) {
    <div ngxSlickItem class="slide">
      @if (item | async; as data) {
      <div
        class="item"
        [class.has-erp-promo]="atLeastOneHasErpPromo"
        [class.has-hybris-promo]="atLeastOneHasHybrisPromo"
      >
        <a tabindex="0" (click)="goToPdp(data, $event, i + 1)">
          <span #prodImageElement [style.height.px]="size" class="prod-image product-carousel-image">
            <cx-media
              [style.height.px]="size"
              [style.background-size.px]="size"
              [container]="getImageRendition(data?.images?.PRIMARY)"
              format="product"
              [class.is-missing-fish]="businessType === 'fish'"
              removeImageTitleAttr
            >
            </cx-media>
          </span>
          <span class="prod-sku">
            {{ data.code }}
          </span>
          <span class="prod-name" [innerHTML]="data.name"></span>
          <span class="prod-price">
            @if (!showSrp) {
            <span class="p-label">{{ 'productCarousel.dealerPriceLabel' | cxTranslate }}</span>
            <span class="p-price" [class.erp-promo]="erpPromoValue(data?.code) && erpPromoValue(data?.code) !== ''">
              @if (!dealerPrice(data.code)) {
              <div class="spinner-shimano-wrapper-dp">
                @if (tooltipIconConfig$ | async; as tooltipIconConfig) { @if (hasDealerPrice) {
                <div class="spinner-shimano">
                  <div></div>
                </div>
                } @if (!hasDealerPrice && !tooltipIconConfig?.enabled) {
                <div class="no-dealer-price no-dealer-price-hp"></div>
                } @else { @if (!hasDealerPrice && tooltipIconConfig?.enabled) {
                <app-tooltip-icon
                  [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
                  dealerPriceIconContainerClass="no-dealer-price-hp"
                  [uniqueClass]="data?.code"
                  placement="bottom-right"
                  [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                  [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
                  [noPointerEventsOnElement]="tooltipIconConfig?.noPointerEventsOnElement"
                  [handleEvents]="tooltipIconConfig?.handleEvents"
                ></app-tooltip-icon>
                } } }
              </div>
              } @else {
              {{ dealerPrice(data.code) }}@if (dealerPrice(data.code) && showGstExclusive$ | async) {
              <span class="gst-label">{{ 'productCarousel.gstExclusive' | cxTranslate }}</span>
              } }
            </span>
            } @if (showSrp) {
            <span class="p-label">{{ 'productCarousel.srpLabel' | cxTranslate }}</span>
            <span class="p-price"
              >{{ data.srpPrice?.formattedValue }}@if (data.srpPrice?.formattedValue && showGstInclusive$ | async) {
              <span class="gst-label">{{ 'productCarousel.gstInclusive' | cxTranslate }}</span>
              }</span
            >
            }
          </span>
          @if (dealerPrices && !showSrp) {
          <app-erp-promotional-text
            class="d-xl-block promotional-text"
            [dealerPriceData]="dealerPriceData(data?.code)"
          ></app-erp-promotional-text>
          } @if (!showSrp && dealerPrices) {
          <app-promotional-text
            [productCode]="data.code"
            [product]="data"
            [dealerPriceData]="dealerPriceData(data.code)"
            [promotionLocation]="'CAROUSEL'"
            [charactersLimit]="40"
          ></app-promotional-text>
          }
        </a>
      </div>
      }
    </div>
    }
  </ngx-slick-carousel>
  }
</div>
}
